import { api } from '@/lib/api'

/**
 * @returns {Promise<Array<{ id: number, code: string, name: string, account_type: string, is_system: boolean }>>}
 */
export async function fetchChartOfAccounts() {
  const { data } = await api.get('/accounts/chart-of-accounts')
  return data.data.chart_of_accounts
}

/**
 * @returns {Promise<object | null>}
 */
export async function fetchOpenCashShift() {
  const { data } = await api.get('/accounts/cash-shifts/open')
  return data.data.cash_shift
}

/**
 * @returns {Promise<object[]>}
 */
export async function fetchCashShifts() {
  const { data } = await api.get('/accounts/cash-shifts')
  return data.data.cash_shifts
}

/**
 * @param {number} openingFloat
 */
export async function openCashShift(openingFloat) {
  const { data } = await api.post('/accounts/cash-shifts/open', {
    opening_float: openingFloat,
  })
  return data.data.cash_shift
}

/**
 * @param {number} shiftId
 * @param {{ closing_cash_counted: number, notes?: string }} payload
 */
export async function closeCashShift(shiftId, payload) {
  const { data } = await api.post(`/accounts/cash-shifts/${shiftId}/close`, payload)
  return data.data
}

/**
 * @returns {Promise<object[]>}
 */
export async function fetchZReports() {
  const { data } = await api.get('/accounts/z-reports')
  return data.data.z_reports
}

/**
 * @param {{ from?: string, to?: string }} [params]
 */
export async function fetchDayBook(params = {}) {
  const { data } = await api.get('/accounts/ledgers/day-book', { params })
  return data.data
}

/**
 * @param {{ voucher_date: string, narration: string, lines: Array<{ chart_of_account_id: number, debit?: number, credit?: number }> }} payload
 */
export async function createJournalVoucher(payload) {
  const { data } = await api.post('/accounts/vouchers', payload)
  return data.data.voucher
}

/**
 * @param {number | string | null | undefined} value
 */
export function formatLedgerMoney(value) {
  const num = Number(value ?? 0)
  return Number.isFinite(num) ? num.toFixed(2) : '0.00'
}

/**
 * @param {Array<{ debit?: number | string, credit?: number | string }>} lines
 */
export function journalLineTotals(lines) {
  const debit = lines.reduce((sum, line) => sum + Number(line.debit || 0), 0)
  const credit = lines.reduce((sum, line) => sum + Number(line.credit || 0), 0)

  return {
    debit: Math.round(debit * 100) / 100,
    credit: Math.round(credit * 100) / 100,
    balanced: Math.abs(debit - credit) < 0.01,
  }
}
